<div class="home-page">

  @if (userInfo$ | async; as volunteer) {

    <!-- HERO / BIENVENIDA -->
    <section class="welcome-card">

      <div class="welcome-copy">
        <span class="eyebrow">Panel de Voluntario General</span>

        <h1>
          Bienvenido,
          <span>{{ volunteer.fullName || volunteer.mail }}</span>
        </h1>

        <p>
          Consulta tu información institucional, actividades asignadas y
          participación comunitaria en ABAQ desde un mismo lugar.
        </p>
      </div>

      <div class="welcome-badge">
        <div class="badge-initial">
          {{ (volunteer.fullName || volunteer.mail || '?').charAt(0) }}
        </div>

        <div class="badge-info">
          <strong>{{ volunteer.fullName || 'Voluntario General' }}</strong>
          <span>{{ volunteer.mail }}</span>
          @if (volunteer.folio) {
            <span class="badge-folio">Folio: {{ volunteer.folio }}</span>
          }
        </div>
      </div>

    </section>


    <!-- RESUMEN RÁPIDO (SIN CONTEO DE HORAS) -->
    <section class="quick-stats">

      <div class="stat-card">
        <span class="stat-label">Ocupación</span>
        <strong>{{ volunteer.occupation || 'Voluntario' }}</strong>
        <span class="stat-help">Perfil profesional</span>
      </div>

      <div class="stat-card">
        <span class="stat-label">Folio Institucional</span>
        <strong>{{ volunteer.folio || 'Pendiente' }}</strong>
        <span class="stat-help">Expediente único oficial</span>
      </div>

      <div class="stat-card">
        <span class="stat-label">Estatus de Cuenta</span>
        <strong>{{ volunteer.accountStatus === 'active' ? 'Activo' : 'En validación' }}</strong>
        <span class="stat-help">Estado en plataforma</span>
      </div>

      <div class="stat-card">
        <span class="stat-label">Actividades Registradas</span>
        <strong>{{ volunteer.assignedActivities.length }}</strong>
        <span class="stat-help">Total asignadas</span>
      </div>

      <div class="stat-card">
        <span class="stat-label">Actividades Pendientes</span>
        <strong>{{ pendingActivities.length }}</strong>
        <span class="stat-help">Por participar</span>
      </div>

      <div class="stat-card">
        <span class="stat-label">Actividades Concluidas</span>
        <strong>{{ activityHistory.length }}</strong>
        <span class="stat-help">Historial de participación</span>
      </div>

    </section>


    <!-- INFORMACIÓN DEL VOLUNTARIO -->
    <section class="info-card">

      <div class="section-title">
        <div>
          <span class="section-kicker">Perfil</span>
          <h2>Información del voluntario</h2>
          <p>
            Datos registrados en tu expediente institucional de voluntariado.
          </p>
        </div>
      </div>

      <div class="student-name-block">
        <div class="student-avatar">
          {{ (volunteer.fullName || volunteer.mail || '?').charAt(0) }}
        </div>

        <div>
          <h3>{{ volunteer.fullName || volunteer.mail }}</h3>
          <span>{{ volunteer.mail }}</span>
        </div>
      </div>

      <div class="student-grid">

        @for (field of displayFields; track field.key) {
          <div class="info-field">

            <span class="info-label">
              {{ field.label }}
            </span>

            <span class="info-value">
              @if (field.isDate) {
                {{ (getFieldValue(volunteer, field.key) | date:'dd/MM/yyyy') || 'N/A' }}
              } @else {
                {{ getFieldValue(volunteer, field.key) || 'N/A' }}
              }
            </span>

          </div>
        }

      </div>

    </section>


    <!-- ACTIVIDADES PENDIENTES (SIN HORAS) -->
    <section class="pending-card">

      <div class="section-title pending-title">
        <div>
          <span class="section-kicker">Seguimiento</span>
          <h2>Actividades pendientes</h2>
          <p>
            Actividades en las que estás registrado o marcaste tu asistencia para validación.
          </p>
        </div>

        <div class="section-count">
          <strong>{{ pendingActivities.length }}</strong>
          <span>pendientes</span>
        </div>
      </div>

      <div class="pending-list">

        @for (activity of pendingActivities; track activity.activityRef) {

          <article class="pending-item">

            <div class="pending-icon">
              !
            </div>

            <div class="pending-main">

              <span class="pending-label">
                {{ activity.type }}
              </span>

              <h3>
                {{ activity.title }}
              </h3>

              <div
                class="activity-status"
                [class.status-registered]="activity.status === 'registered'"
                [class.status-attended]="activity.status === 'attended'"
              >
                @switch (activity.status) {
                  @case ('registered') {
                    Registrado
                  }

                  @case ('attended') {
                    Asistió
                  }
                }
              </div>

            </div>

            <div class="pending-meta">

              <div>
                <span>Fecha límite</span>
                <strong>
                  {{ activity.dueDate | date:'mediumDate' }}
                </strong>
              </div>

              <div>
                <span>Participación</span>
                <strong>
                  Confirmada
                </strong>
              </div>

            </div>

          </article>

        } @empty {

          <div class="empty-pending">
            <strong>No tienes actividades pendientes</strong>
            <span>
              Cuando te registres a una actividad comunitaria aparecerá aquí.
            </span>
          </div>

        }

      </div>

    </section>


    <!-- HISTORIAL DE ACTIVIDADES (SIN HORAS) -->
    <section class="pending-card history-card">

      <div class="section-title pending-title">
        <div>
          <span class="section-kicker">Historial</span>
          <h2>Historial de actividades</h2>
          <p>
            Actividades finalizadas o registradas como no asistidas.
          </p>
        </div>

        <div class="section-count">
          <strong>{{ activityHistory.length }}</strong>
          <span>registros</span>
        </div>
      </div>

      <div class="pending-list">

        @for (activity of activityHistory; track activity.activityRef) {

          <article class="pending-item">

            <div
              class="pending-icon"
              [class.history-validated]="activity.status === 'validated'"
              [class.history-absent]="activity.status === 'absent'"
            >
              @if (activity.status === 'validated') {
                ✓
              } @else {
                ✕
              }
            </div>

            <div class="pending-main">

              <span class="pending-label">
                {{ activity.type }}
              </span>

              <h3>
                {{ activity.title }}
              </h3>

              <div
                class="activity-status"
                [class.status-validated]="activity.status === 'validated'"
                [class.status-absent]="activity.status === 'absent'"
              >
                @switch (activity.status) {
                  @case ('validated') {
                    Asistencia acreditada
                  }

                  @case ('absent') {
                    No asistió
                  }
                }
              </div>

            </div>

            <div class="pending-meta">

              <div>
                <span>Fecha</span>
                <strong>
                  {{ activity.dueDate | date:'mediumDate' }}
                </strong>
              </div>

              <div>
                <span>Desempeño</span>
                <strong>
                  @switch (activity.status === 'absent' ? 'absent' : activity.performance) {
                    @case ('very_bad') {
                      Muy malo
                    }
                    @case ('bad') {
                      Malo
                    }
                    @case ('good') {
                      Bueno
                    }
                    @case ('very_good') {
                      Muy bueno
                    }
                    @case ('excellent') {
                      Excelente
                    }
                    @case ('absent') {
                      Inasistencia
                    }
                    @default {
                      Participó
                    }
                  }
                </strong>
              </div>

              <div>
                <span>Comentarios</span>

                <strong
                  [class.comment-expanded]="
                    expandedComments.has(activity.activityRef)
                  "
                >
                  {{ activity.performanceComment || 'Sin comentarios' }}
                </strong>

                @if (activity.performanceComment) {
                  <button
                    type="button"
                    class="comment-toggle"
                    (click)="toggleComment(activity.activityRef)"
                  >
                    {{
                      expandedComments.has(activity.activityRef)
                        ? 'Ocultar comentario'
                        : 'Ver comentario'
                    }}
                  </button>
                }
              </div>

            </div>

          </article>

        } @empty {

          <div class="empty-pending">
            <strong>Aún no tienes historial</strong>
            <span>
              Las actividades en las que participes aparecerán aquí.
            </span>
          </div>

        }

      </div>

    </section>


    <!-- GRÁFICAS INSTITUCIONALES -->
    <div class="dashboard-charts">

      <div class="chart-card">
        <div class="chart-header">
          <h3>Participación en actividades</h3>
          <p>Actividades concluidas (azul) vs pendientes (naranja).</p>
        </div>

        <div class="chart-wrapper doughnut-wrapper">
          <canvas id="volProgressChart"></canvas>
        </div>
      </div>

      <div class="chart-card">
        <div class="chart-header">
          <h3>Participación en el tiempo</h3>
          <p>Historial cronológico de actividades comunitarias.</p>
        </div>

        <div class="chart-wrapper">
          <canvas id="volTimeChart"></canvas>
        </div>
      </div>

    </div>

  } @else {

    <div class="loading-state">
      <div class="loading-dot"></div>
      <h3>Cargando información del voluntario general...</h3>
    </div>

  }

</div>
